import { render, staticRenderFns } from "./POIListItem.vue?vue&type=template&id=38b2dcef&scoped=true"
import script from "./POIListItem.vue?vue&type=script&lang=ts"
export * from "./POIListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2dcef",
  null
  
)

export default component.exports